import React from "react";
//#region types
import { DraggableInvoiceProductRowProps, InvoiceContentSelectionFormType } from "models/propTypes/invoicePropTypes";
//#endregion
//#region components
import InvoiceProductRow from "./productRow";
import { useDrag, useDrop } from "react-dnd";
import type { Identifier } from "dnd-core";
//#endregion

const DraggableInvoiceProductRow: React.FC<DraggableInvoiceProductRowProps<InvoiceContentSelectionFormType>> = (
  props
) => {
  const { index } = props;
  const dragDropRef = React.useRef<HTMLTableRowElement>(null);

  const [{ handlerId, isOver }, drop] = useDrop<any, void, { handlerId: Identifier | null; isOver: boolean }>({
    accept: "InvoiceProductRow",
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
        isOver: monitor.isOver(),
      };
    },
    //hover: hover,
    drop(item) {
      if (item.index === index) return;
      props.moveRow(item.index, index);
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: "InvoiceProductRow",
    item: () => ({
      id: props.row.uniqueId,
      index: index,
    }),
    collect: (monitor: any) => ({
      isDragging: monitor.isDragging(),
    }),
    canDrag: props.canDrag,
  });

  drag(drop(dragDropRef));

  return (
    <InvoiceProductRow
      {...props}
      dragDropRef={dragDropRef}
      handlerId={handlerId}
      isDragging={isDragging}
      isOver={isOver}
    />
  );
};

export default DraggableInvoiceProductRow;
